import { action, makeObservable, observable } from 'mobx';
import { Revenue } from 'src/integration/types/Revenue';

class RevenueStore {
  @observable revenue: Revenue[] = [];

  @action setRevenueData = (data: SimpleObject[]) => {
    this.revenue = data as Revenue[];
  };

  constructor() {
    makeObservable(this);
  }
}

export default RevenueStore;
